import React, { Component } from 'react'
import axios from '../../axios'
import format from 'format-number'
import { DateRangePicker } from 'react-dates'
import Alert from 'react-s-alert'

class Lists extends Component {

    constructor() {
        super();
        this.state = {
            startDate           : null,
            endDate             : null,
            dataHistori         : [],
            filter_keyword      : "",
            filter_tgl_dari     : "",
            filter_tgl_sampai   : "",
            isLoading           : true
        }

        this.handleChange   = this.handleChange.bind(this)
        this.handleResetFilter = this.handleResetFilter.bind(this)
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })        
    }

    loadData() {
        
        const keyword    = this.state.filter_keyword;
        const tgl_dari   = this.state.filter_tgl_dari;
        const tgl_sampai = this.state.filter_tgl_sampai;

        axios({
            method: 'get',
            url: '/saldo/getPenggunaanSaldo?tipe=sekolah&keyword=' + keyword + '&tgl_dari=' + tgl_dari + '&tgl_sampai=' + tgl_sampai
        })
        .then(response => {
            this.setState({
                dataHistori : response.data,
                isLoading   : false
            })
        })
        .catch(error => {
            
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }

    handleResetFilter() {
        this.setState({
            filter_keyword      : "",
            filter_tgl_dari     : "",
            filter_tgl_sampai   : "",
            startDate           : null,
            endDate             : null,
        })
    }
    
    componentDidMount() {
        
        this.loadData()        
    }

    componentDidUpdate(nextProps, nextState) {
        
        if (this.state.filter_keyword !== nextState.filter_keyword ||
            this.state.filter_tgl_dari !== nextState.filter_tgl_dari ||
            this.state.filter_tgl_sampai !== nextState.filter_tgl_sampai ) {

            this.loadData()
        }
    }    

    render () {
        
        const listData = this.state.dataHistori === null || this.state.dataHistori.length === 0 ? null : (

            this.state.dataHistori.map((item) => {
                return (
                    <tr key={item.id_penggunaan}>
                        <td>{item.nama_item}</td>
                        <td>{format({prefix: 'Rp ', integerSeparator: "."})(item.nominal_diterima)}</td>
                        <td>{item.penggunaan_saldo_create_date}</td>
                        <td>{item.nama_anggota}</td>
                        <td>{item.nis}</td>
                        <td>{item.pendidikan_nisn}</td>
                        <td>{item.kelas}</td>
                    </tr>
                )
            })
        )

        return (
            
            <div className="col-sm-12">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            Data Histori Transaksi
                        </div>
                        <div className="card-block">
                            <div style={{marginBottom: "30px"}}>                                
                                <div className="form-group row">
                                    <div className="col-md-5">
                                        <label className="form-form-control-label text-muted">Filter Data</label>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-form-control-label text-muted">Filter Tanggal Transaksi</label>
                                    </div>
                                    <div className="col-md-12"></div>
                                    <div className="col-md-5">
                                        <input
                                            type="text"
                                            name="filter_keyword"
                                            className="form-control"
                                            onChange={this.handleChange}
                                            value={this.state.filter_keyword}
                                            placeholder="Ketik Nama Siswa / Nomor Induk / NISN ..."/>
                                    </div>
                                    <div className="col-md-6">
                                        <DateRangePicker
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            startDatePlaceholderText="Tgl Dari"
                                            endDatePlaceholderText="Tgl Sampai"
                                            onDatesChange={({ startDate, endDate }) =>
                                                this.setState({
                                                    startDate,
                                                    endDate,
                                                    filter_tgl_dari: startDate === null ? "" : startDate.format('YYYY-MM-DD'),
                                                    filter_tgl_sampai: endDate === null ? "" : endDate.format('YYYY-MM-DD'),
                                                })
                                            }
                                            focusedInput={this.state.focusedInput}
                                            onFocusChange={focusedInput => this.setState({ focusedInput })}
                                        />
                                        {" "}
                                        <button
                                            className="btn btn-md btn-primary"
                                            onClick={this.handleResetFilter}
                                        >
                                            Reset Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.isLoading ? "Memuat Data..." : (
                                    listData === null ? "Data Kosong..." : (
                                        <table className="table table-striped animated fadeIn">
                                            <thead>
                                                <tr>
                                                    <th>Nama Item</th>
                                                    <th>Nominal</th>
                                                    <th>Tanggal Transaksi</th>
                                                    <th>Nama Siswa</th>
                                                    <th>No Induk</th>
                                                    <th>NISN</th>
                                                    <th>Kelas</th>
                                                </tr>
                                            </thead>
                                            <tbody>{listData}</tbody>
                                        </table>   
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
                   
        )
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/HistoriTransaksi/Lists.js